import React,{useState,useContext,useEffect} from 'react';
import clsx from 'clsx';
import config from './config.js'
import MessageParser from './MessageParser.js'
import ActionProvider from './ActionProvider.js'
import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';
import Cookies from 'universal-cookie';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import DashboardIcon from '@material-ui/icons/Adjust';
import PaymentIcon from '@material-ui/icons/Adjust';
import ReceiptIcon from '@material-ui/icons/Adjust';
//import PaymentIcon from '@material-ui/icons/Payment';
// import ReceiptIcon from '@material-ui/icons/Receipt';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LanguageIcon from '@material-ui/icons/Language';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
// import Image from "./3750360 2.png"
import {Image} from 'react-bootstrap'
import DrawerImage from "./Drawer.png"
import {UserContext} from "./Context/UserContext"
import {Accordion,DropdownButton,ButtonGroup,Dropdown} from "react-bootstrap"
import { Link, Redirect } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Collapse, Button, CardBody, Card, UncontrolledCollapse} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios"
//import 'fontsource-roboto';
import "../App.css"
import Login from "./Login"
import GetUserAddress from './ReadyToShop'
import { base_url } from '../globalConstants';
import imagebg from "./customerbg.png"; 
import imagecusthead from "./custhead.png"; 
const drawerWidth = 240;


 
const useStyles = makeStyles((theme) => ({
  root:{
    display:'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },

 
}));

export default function CustomerDashboard({Logged}) {
  const cookies = new Cookies();
  console.log( 'languaecus--get',cookies.get('language'))
  const [userDetails,setUserDetails]=useState({})
  const [isEmailValidated, setIsEmailValidated] = useState(false)

  const [show, setShow] = useState(false);
  const [hideModal, setHideModal] = useState(false);

  const classes = useStyles();
  const theme = useTheme();

  const context=useContext(UserContext);
  
  const [open, setOpen] = React.useState(false);

  const [PersonName,setPersonName]=useState('')

  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);

  const [username,setUsername]=useState('')
  const [validated,setValidated]=useState(false);
  const [EzzId,setEzzId]=useState('')
  const [userLanguage, setUserLanguage] = useState('')
  const [screenWidth, setScreenWidth] = useState('')
  const [isWideScreen, setIsWideScreen] = useState(false)
  const [defLang, setDefLang] = useState('')
  const [TotalIM, setTotalIM] = useState(0);
  const [Total, setTotal] = useState(0);
  //const [Logged, setLogged]=useState(false);

  const notify = () => toast("Wow so easy !");

  const toggle = () => setIsOpen(!isOpen);
  const toggle1 = () => setIsOpen1(!isOpen1);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  
  const handleLanguageChange =  e =>  {
  axios({
    method: 'patch',
    url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
    data: {'language':e},
    headers: { 'Content-Type': 'application/json' },
    
  }).then(function(response){
    console.log(response)
    console.log(response.data)
    setUserLanguage(e)
    toast(`Your Language has been changed to ${e}`)
    if( e == "Spanish")
        setDefLang('Español')
      else
        setDefLang('English')
    })
    .catch(function(response){
    console.log(response)
  })
  } 
  
  // function checkLogin(){
  //   if(localStorage.getItem('logged')===false){
  //     console.log('here')
  //     setLogged(false);
  //     return <Redirect to="/"/>
  //   }else{
  //     setLogged(true);
  //   }
  // }
 
  // function routelogin(){
  //   return <Redirect to="/"/>
  // }

  // const handleClose = () =>{
  //   setShow(false)
  // }


  const checkUserAddress = () => {

    axios({
      method: 'get',
      url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
      headers: { 'Content-Type': 'application/json' }
    }).then(function(response){
      console.log(response)
      console.log(response.data)

      const userDetails =  response.data


      setIsEmailValidated(response.data.email_validated)
      setUserDetails(userDetails)
      setUserLanguage(response.data.language)

      if( response.data.language == "Spanish")
        setDefLang('Español')
      else
        setDefLang('English')

        if (!userDetails.address || !userDetails.state || !userDetails.city || !userDetails.zipcode ) {
          setShow(true)   
        } else
          setShow(false)   

    }).catch(function(response){
      console.log(response);
    })

   

  }

const fetchDetails=async()=>{
        const ezz = localStorage.getItem('ezzyid');
        //const response=await axios.get(base_url+`boxes_received/?ezz_id=${ezz}`)
        const response=await axios.get(base_url+`getOrderCount?ezz_id=${ezz}`)
        const {data}=response;
        // console.log(data);
        //alert(data.results);
        var arrdata = data.split(';');
        var arrim = arrdata[0].split(':');
        var arrtot = arrdata[1].split(':');
        var total_im = arrim[1];
        var total_order = arrtot[1];
        // data.results.forEach(function(item){
        //   if (item.current_status_name == 'Invoice Missing')
        //   {
        //     total_im = total_im + 1;
        //     total_order = total_order + 1;
        //   }
        //   else if (item.current_status_name != "Box Unidentified" && item.current_status_name != "Discarded" )
        //   {
        //     total_order = total_order + 1;
        //   }
          
        // })
        setTotalIM(total_im);               ;
        setTotal(total_order);
        //setPreviousPageUrl(data.previous);
        //setNextPageUrl(data.next);

    }
 useEffect(()=>{
   fetchDetails();
  //setLogged(localStorage.getItem('logged'));
  

  // const token=localStorage.getItem('token');
  // if(token){
  //   setLogged(true);
  // }
  //checkLogin();
  //setLogged(localStorage.getItem('logged'))
  setUsername(localStorage.getItem('username'));
  setValidated(localStorage.getItem('validated'));
  setEzzId(localStorage.getItem('ezzyid'));
  // setLogged(localStorage.getItem('logged'));
  
  // console.log(localStorage.getItem('logged' ), 'logged state from useffecr')
  
  checkUserAddress()
  
 

 },[])

 useEffect(() => {
  var w = window.innerWidth;
  console.log('window.innerWidth',w)
  setScreenWidth(w)
  if(w<900)
    setIsWideScreen(true)
  else
    setIsWideScreen(false)
 }, [])

const myStyle={
        
        backgroundImage:`url(${imagebg})`,
        height:'100vh',
        marginTop:'-11%',
        fontSize:'50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    };

const lnkcolor = {
        backgroundColor: 'transeparent'
      }

const myStylehead={
        
        backgroundImage:`url(${imagecusthead})`,
        height:'10vh',
        // marginTop:'-70px',
        // fontSize:'50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    };

  return (
  

    <div className={classes.root} >
    {localStorage.getItem('logged') ==='true' ? ' ': <Redirect to="/"/>}
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >

      
        <Toolbar style={{backgroundColor:"white"}}>
          <IconButton
            color="Blue"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          
          <Image src="assets/images/group-4-copy.png" />  
          <Image src="assets/images/custhead.png"  style={{marginLeft:"15%"}}/> <h6 style={{ marginTop:"6.1%", marginLeft:"-8.5%", color:"blue"}}>ID:{EzzId}</h6>                  
          {/* <Typography variant="h4" id="ezzy" noWrap >
            EzzyShip
          </Typography> */}
		  {/*<IconButton float="right" style={{marginLeft:"40%" }}> <HelpOutlineIcon style={{color:"#4C4B4B",width:"30px",height:"30px"}}/></IconButton>*/}
         <IconButton float="right" style={{marginLeft:"20%" }}> </IconButton>
         
		 
			 {/*<PersonPinIcon  style={{color:"#4C4B4B",width:"40px",height:"40px"}}/>*/}
         <DropdownButton id="bg-vertical-dropdown-1" edge="end" title={userLanguage} className='myAccountDropdown'>
         <Dropdown.Item as={ButtonGroup} onClick={()=>handleLanguageChange('English')}>English</Dropdown.Item>
         <Dropdown.Item as={ButtonGroup}onClick={()=>handleLanguageChange('Spanish')}>Spanish</Dropdown.Item>
         </DropdownButton>
         <DropdownButton id="bg-vertical-dropdown-1" edge="end" title="My Account " className='myAccountDropdown'> 
        <Link to="/userprofile"><Dropdown.Item as={ButtonGroup}>My Profile</Dropdown.Item></Link>
        <Link to="/"> <Dropdown.Item as={ButtonGroup} onClick={()=>{
          localStorage.removeItem("token");
          localStorage.removeItem("ezzname");
          localStorage.removeItem("ezzyid");
          localStorage.removeItem("username")
          localStorage.setItem('logged', 'false');
          //setLogged(false);

        }} eventKey="2">Sign Out</Dropdown.Item></Link>

            <Dropdown.Divider />
            
            <div style={{ textAlign: 'center', backgroundColor: '#80808021' }}>
              <h6>My EzzyShip Address</h6>
                  <p>
                    12281 SW 132ND CT<br/>
                    SUITE # {localStorage.getItem("ezzyid")}<br/>
                    MIAMI, FL 33186
                  </p>
            </div>
         </DropdownButton>
         
         {/* <DropdownButton id="bg-vertical-dropdown-1" edge="end" title="Change Language" className='myAccountDropdown'>
         <Dropdown.Item as={ButtonGroup} onClick={()=>{
          localStorage.removeItem("Englsh");
          localStorage.removeItem("Spanish");
         </DropdownButton> */}
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        {/*<Divider />*/}
        <List style={{backgroundColor: "transparent"}} id="listleft">

          {
            // isEmailValidated
            true
            ?
              <>
                <Link to="/customerdashboard"  ><ListItem button>
                    <ListItemIcon  style={{height:"2px"}}> <DashboardIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Dashboard1' primary="DashBoard3" />
                </ListItem></Link>
                                <Link to="/orderlist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Order List' primary="Invoice Missing" />
                </ListItem></Link>  
                <Link to="/orderlist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Order List' primary="My Orders" />
                </ListItem></Link>  

                <Link to="/paymentauth"><ListItem button>
                    <ListItemIcon  style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Payment Authorization' primary="Add Payment" />
                </ListItem></Link>
                <Link to="/calculator">
                <ListItem button>
                    <ListItemIcon  style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Calculator' primary="EZZY Estimator" />
                </ListItem>
                </Link> 
                <Link to="/referrallist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Referral' primary="Refer A Friend" />
                </ListItem></Link>
                 <Link to="/couponlist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Coupon List' primary="My Coupons" />
                </ListItem></Link> 
				<Link to="/changepwd">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Change Password' primary="Change Password" />
                </ListItem>
                </Link> 
                <Link to="/changemethod">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Change Shipping' primary="Change Shipping" />
                </ListItem>
                </Link> 

				                      <Link to={{pathname:"https://youtu.be/Hk1RFcpq20g"}} target="_blank">	
                  <ListItem button>	
                      <ListItemIcon style={{height:"2px"}}> <ReceiptIcon /></ListItemIcon>	
                      <ListItemText  style={{height:"2px"}} title='How We Work' primary="How We Work" ></ListItemText>	
                  </ListItem>	
				    </Link> 				

               

                                <Link to="/customerdashboard"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <DashboardIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Dashboard1' primary="Contact Us" />
                </ListItem></Link>
                <Link to="/customerdashboard"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Payment Authorization' primary="Self Help" />
                </ListItem></Link>
               
				<Link to="/changepwd">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} onClick={() => {
                            localStorage.removeItem("token");
                            localStorage.removeItem("ezzname");
                            localStorage.removeItem("ezzyid");
                            localStorage.removeItem("username")
                            localStorage.setItem('logged', 'false'); 

                          }} title='Change Password' primary="Sign Out" />
                </ListItem>
                </Link> 
                 

 	
                {
                  isWideScreen
                  ?
                    <>
                      <Divider />
                      <Link to="/userprofile">
                      <ListItem button>
                        <ListItemIcon > <PersonIcon /></ListItemIcon>
                        <ListItemText title='My Profile' primary="My Profile" />
                      </ListItem>  
                      </Link>
                      <Link>
                      
                      <ListItem button>
                        <ListItemIcon > <LanguageIcon /></ListItemIcon>
                        <ListItemText title={defLang} primary={defLang} 
                          onClick={()=> { 
                            if(userLanguage == 'English')
                              handleLanguageChange('Spanish')
                            else
                              handleLanguageChange('English')
                          }}
                        />
                      </ListItem>  
                      </Link>
                      <Link to="/">
                      <ListItem button>
                        <ListItemIcon > <ExitToAppIcon /></ListItemIcon>
                        <ListItemText as={ButtonGroup} title='Sign Out' primary="Sign Out"
                          onClick={() => {
                            localStorage.removeItem("token");
                            localStorage.removeItem("ezzname");
                            localStorage.removeItem("ezzyid");
                            localStorage.removeItem("username")
                            localStorage.setItem('logged', 'false'); 

                          }} >Sign Out</ListItemText>
                         </ListItem> 
                        </Link>                        
                    </>
                  :' '
                }       
              </>
              
            :
              <>
                <ListItem button>
                  <ListItemIcon> <DashboardIcon /></ListItemIcon>
                  <ListItemText title='Dashboard2' primary="DashBoard3" />
                </ListItem>
                <ListItem button>
                  <ListItemIcon> <PaymentIcon /></ListItemIcon>
                  <ListItemText  title='Payment Authorization'  primary="Payment Auth" />
                </ListItem>
                {/* <Link to="/calculator">*/}
                <ListItem button>
                  <ListItemIcon> <PaymentIcon /></ListItemIcon>
                  <ListItemText  title='Calculator'  primary="Calculator" />
                </ListItem>
                {/* </Link>  */}
                <ListItem button>
                  <ListItemIcon> <ReceiptIcon /></ListItemIcon>
                  <ListItemText  title='Order List'  primary="Order List" />
                </ListItem>
                <ListItem button>
                  <ListItemIcon> <ReceiptIcon /></ListItemIcon>
                  <ListItemText  title='Change Password'  primary="Change Password" />
                </ListItem>
				<Link to="/referrallist"><ListItem button>
                    <ListItemIcon> <ReceiptIcon /></ListItemIcon>
                    <ListItemText  title='Referral' primary="Referral" />
                </ListItem></Link> 
				
              </>
          }

        </List>


        {/*<Divider />*/}

        <img src={DrawerImage} style={{ marginLeft:"5%", height: "230px", width: "200px", marginTop: "30%" }} />




      </Drawer>
      <main style={{backgroundColor:"white"}}
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />
    
      
        
        
        <Grid container spacing={8}>
          <Grid item xs={6}>
            <h5 style={{marginTop:"2%", float:'left', color:"black"}}>Welcome {username} !</h5>
          </Grid>
          <Grid item xs={6}>
            <div style={{marginTop:"2%", textAlign: 'left'}}>
                <h5>My US Address</h5>
                    <p>
                      <h6>
                      12281 SW 132ND CT<br/>
                      SUITE # {localStorage.getItem("ezzyid")}<br/>
                      MIAMI , FL 33186
                      </h6>
                    </p>
              </div>
            </Grid>
    {/*<Grid item xs={3}>
    
    </Grid>*/}
     
    <Grid item xs={12}>

    </Grid>
       
        
        
      <Grid item xs={12}>
        {
          // isEmailValidated
          true
          ?""
          :
            <div>
              <br/><br/>
              <h3 className="paydash" id="paymentreminder">Confirm email to access account.</h3>
            </div>
        }      

      {/* <img src='assets/images/3750360 2.png' style={{alignSelf:"center",width:"auto", height:"500px", marginLeft:"20%"}} /> */}
      </Grid>
      </Grid>

	<Grid container direction="column" style={{backgroundImage: "url('./assets/images/customerbg.png')",height:'95%',
        marginTop:'-11%',
        width:'100%',
        fontSize:'50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'}} justifyContent="center" alignItems="center" spacing={16}>
	{
		true
		?
		<>
    <Grid container justifyContent="center" alignItems="center" spacing={16}>
        <Grid item>
          <a href="/orderlist" >
            <img src="assets/images/invoice_missing.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={6} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs >
              <Typography gutterBottom >  <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; Invoice Missing  | <font style={{fontWeight: "bold", color:"darkblue", textDecorationLine: 'underline', fontSize: '1.3em'}} > {TotalIM.toString()}</font></font></h6></Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

	     
	  
      <Grid container justifyContent="center" alignItems="center" spacing={16}>
        <Grid item>
          {/*<img src="assets/images/AUTHORIZE CARD.png" width="50px" height="50px" color="white"/>*/}
           <a href="/orderlist" >
            <img src="assets/images/myorder.png" width="50px" height="50px" color="white"/>
          </a>
        </Grid>
        <Grid item xs={6} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs>
              <Typography gutterBottom>
                   <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; My Orders | <font style={{fontWeight: "bold", color:"darkblue", textDecorationLine: 'underline', fontSize: '1.3em'}} > {Total.toString()}</font></font></h6>
                    {/*<ListItemText  title='Order List' primary="Order List" />*/}
                </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
			
      <Grid container justifyContent="center"  alignItems="center" spacing={16}>
        <Grid item>
          <a href="/paymentauth" >
            <img src="assets/images/payment.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs>
              <Typography gutterBottom>   <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; Add Payment Method</font></h6></Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <a href="/calculator" >
            <img src="assets/images/calculator.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs>
              <Typography gutterBottom>   <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; EZZY Estimator</font></h6></Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" alignItems="center" spacing={16}>
        
      </Grid>

 <Grid container justifyContent="center" alignItems="center" spacing={16}>
        <Grid item>
          <a href="/referrallist" >
            <img src="assets/images/referral.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs >
              <Typography gutterBottom >  <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; Refer A Friend</font></h6></Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <a href="/couponlist" >
            <img src="assets/images/coupon.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs >
              <Typography gutterBottom >  <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; My Coupons</font></h6></Typography>
            </Grid>
          </Grid>
        </Grid>

      </Grid>

 <Grid container justifyContent="center" alignItems="center" spacing={16}>
        
      </Grid>

      <Grid container justifyContent="center" alignItems="center" spacing={16}>
	
	<Chatbot config={config} messageParser={MessageParser} actionProvider={ActionProvider} />

        <Grid item>
          <a href="/userprofile" >
            <img src="assets/images/profile.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs>
              <Typography gutterBottom>  <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; My Profile</font></h6> </Typography>
            </Grid>
          </Grid>
        </Grid>

          <Grid item>
          <a href="/ChangePwd" >
            <img src="assets/images/change_pwd.png" width="50px" height="50px" color="white"/>
          </a>
          
        </Grid>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs>
              <Typography gutterBottom>   <h6><font style={{color:"#2080D5"}}>&nbsp;&nbsp;&nbsp; Change Password</font></h6></Typography>
            </Grid>
          </Grid>
        </Grid>
        
      </Grid>
	  
	  <Grid container justifyContent="center" alignItems="center" spacing={16}>
      
      </Grid>
			
			
		</>
		:""
	}
	</Grid>
      
      <ToastContainer/>

      {
        show
        ?
          <GetUserAddress showAddressModal = {show} isEditOption = {false} userData={userDetails} /> 
        : ''
      }

      </main>
      
    </div>

  )
      }
